<template>
	<main class="mobile_mypage">
		<div class="user_info_section">
			<section class="box_wrapper">
				<div class="user_box">
					<div class="user_content_img">
						<img v-if="authStore.getUserImg" :src="authStore.getUserImg" loading="lazy" alt="사용자 이미지" />
						<img v-else src="@/assets/img/character/master_01.png" loading="lazy" alt="사용자 이미지" />
					</div>
					<div class="user_info">
						<div class="user_info_title_box">
							<span class="user_info_title">
								<strong>{{ authStore.getMemberNickname }}</strong> 님
							</span>
							<div :class="['subscription_badge', { active: getCheckAuthData?.success }]">
								{{ getCheckAuthData?.success ? '프리미엄' : '일반' }}
							</div>
						</div>
						<button class="logout" @click="onClickLogout">
							<span>로그아웃</span>
							<img src="@/assets/img/common/arrow_next.svg" alt="검색" loading="lazy" />
						</button>
					</div>
				</div>
			</section>
			<section class="box_wrapper">
				<div class="user_subscription_info">
					<p class="user_subscription_info_title">
						<b>{{ authStore.getMemberNickname }}</b> 님의 이번달 등급과 혜택
					</p>
					<div :class="['subscription_badge', { active: getCheckAuthData?.success }]">
						{{ getCheckAuthData?.success ? '프리미엄' : '일반' }}
					</div>
					<p class="user_subscription_info_desc">
						{{
							getCheckAuthData?.success
								? '대가의선택의 모든 서비스를 확인할 수 있어요!'
								: '대가의선택 구독 시 아래의 모든 서비스가 제공됩니다.'
						}}
					</p>

					<!-- // 구독 버튼 임시 주석 261023
					<button v-if="!getCheckAuthData?.success" class="subscription_button" @click="router.push('/payment')">
						구독하기
					</button>
					-->
				</div>
			</section>
		</div>

		<div :class="['menu_section_wrapper', { reverse: !getCheckAuthData?.success }]">
			<div class="menu_section_wrapper_content">
				<hr class="divider" />

				<section v-for="(menu, menu_idx) in MENU_LIST" :key="menu_idx" class="menu_section">
					<div class="title_box">
						<h3 :class="{ premium: menu.title === '프리미엄' }">{{ menu.title }}</h3>
						<p v-if="menu.description">{{ menu.description }}</p>
					</div>
					<div class="menu_list">
						<!-- 텔레그램 버튼 추후 삭제 가능 -->
						<button v-if="menu.title === '프리미엄'" class="menu_item" @click="handleTelegramEventCollect">
							<div>
								<Icon name="telegram" :size="20" color="white" />
								<p>회원 전용 텔레그램 입장</p>
								<IconArrowNext width="20" height="20" />
							</div>
						</button>

						<router-link v-for="(item, item_idx) in menu.menuList" :key="item_idx" class="menu_item" :to="item.path">
							<div>
								<Icon v-if="item.icon" :name="item.icon as IconTypes" :size="20" color="white" />
								<p>{{ item.title }}</p>
								<IconArrowNext width="20" height="20" />
							</div>
						</router-link>

						<!-- 프리미엄 버튼 추후 삭제 가능 -->
						<button
							v-if="menu.title === '프리미엄' && !getCheckAuthData?.success"
							class="menu_item"
							@click="handlePremiumEventCollect"
						>
							<div>
								<Icon name="premium" :size="20" color="white" />
								<p>프리미엄 체험하기 <span class="event_badge">EVENT</span></p>
								<IconArrowNext width="20" height="20" />
							</div>
						</button>

						<router-link
							v-for="(item, item_idx) in menu.gridList"
							:key="item_idx"
							class="menu_grid_item"
							:to="item.path"
						>
							<div>
								<img :src="countryIcon(item_idx)" alt="country" loading="lazy" />
								<p>{{ item.title }}<br />바로가기</p>
							</div>
						</router-link>
					</div>
				</section>
			</div>

			<section class="mainMenu">
				<div v-for="(depth1, depth1_idx) in mypageMenuList" :key="depth1_idx" class="depth1">
					<router-link :to="depth1.path" class="depth1_title">
						{{ depth1.title }}
					</router-link>
				</div>
			</section>
		</div>
	</main>
</template>

<script setup lang="ts">
// constant
// core
import { computed } from 'vue';
import { useRouter } from 'vue-router';

import { useGetCheckAuthApi } from '@/api/auth';
import { usePremiumEventCollectApi } from '@/api/event';
import IconAmerica from '@/assets/img/common/america.svg';
import IconJapan from '@/assets/img/common/japan.svg';
import IconSouthkorea from '@/assets/img/common/southkorea.svg';
// image
import Icon, { IconTypes } from '@/components/atom/icon/Icon.vue';
import IconArrowNext from '@/components/atom/icon/IconArrowNext.vue';
import { mypageMenuList } from '@/constants/menu';
// import { MESSAGE_REQUIRED_UPDATE } from '@/constants/title';
// store
import { useAuthStore } from '@/stores/auth';
import { useLoginPopupStore } from '@/stores/LoginPopup';
// import { useMobileDeviceStore } from '@/stores/mobileDevice';
import { useModalStore } from '@/stores/modal';
// import { usePopupStore } from '@/stores/popup';
import { useTokenStore } from '@/stores/token';
// import { isDeviceAOS, isDeviceIOS, openNativeAppStore } from '@/utils/native';

const MENU_LIST = [
	{
		title: '프리미엄',
		description: '혜택 자세히 보기',
		menuList: [{ title: '월간 산업 리포트', icon: 'deep_research', path: '/benefit?currentTab=프리미엄&page=1' }],
	},
	{
		title: 'Hot 랭킹',
		menuList: [{ title: 'Hot랭킹 활용 방법', icon: 'hot_rank', path: '/notice-detail/133' }],
		gridList: [
			{ title: 'Hot 랭킹', path: '/hot-ranking/kr' },
			{ title: 'Hot 랭킹', path: '/hot-ranking/usa' },
			{ title: 'Hot 랭킹', path: '/hot-ranking/jpn' },
		],
	},
	{
		title: '이달의 포착주',
		menuList: [{ title: '이달의 포착주 활용 방법', icon: 'chart', path: '/notice-detail/205' }],
		gridList: [
			{ title: '이달의 포착주', path: '/subscribe?masterPk=25&tab=3' },
			{ title: '이달의 포착주', path: '/master-stocks/usa?masterPk=25' },
			{ title: '이달의 포착주', path: '/master-stocks/jpn?masterPk=25' },
		],
	},

	{
		title: '마켓타이밍',
		menuList: [{ title: '리밸런싱 달력 보기', icon: 'calendar', path: '/notice-detail/201' }],
		gridList: [
			{ title: '마켓타이밍', path: '/market-timing/kr' },
			{ title: '마켓타이밍', path: '/market-timing/usa' },
			{ title: '마켓타이밍', path: '/market-timing/jpn' },
		],
	},
];

// -----variable-----
const authStore = useAuthStore();
const tokenStore = useTokenStore();
const modalStore = useModalStore();
const loginPopupStore = useLoginPopupStore();
// const mobileDeviceStore = useMobileDeviceStore();
// const popupStore = usePopupStore();
const router = useRouter();

const { data: getCheckAuthData } = useGetCheckAuthApi(
	computed(() => ({
		num: 'ALL',
		student: false,
		enable: true,
	}))
);
const { mutateAsync: mutatePremiumEventCollect } = usePremiumEventCollectApi();

const countryIcon = (idx: number) => {
	return idx === 0 ? IconSouthkorea : idx === 1 ? IconAmerica : IconJapan;
};

const handleTelegramEventCollect = () => {
	// 미구독
	if (!getCheckAuthData.value?.success) {
		modalStore.openModal('GuideModal');
	} else if (getCheckAuthData.value?.data?.member_group_name === '제자회원') {
		loginPopupStore.openPopup({
			icon: 'alert',
			content: '제자 전용 텔레그램은 대가의 선택 상담톡으로 문의바랍니다.',
			cancel: () => {
				router.push('/notice-detail/126');
			},
			cancelText: '상담톡 바로가기',
		});
	} else if (getCheckAuthData.value?.data?.member_group_telegram_link) {
		// const appVersion = mobileDeviceStore.getAppVersion;
		// const currentVersion = appVersion.split('.').map((item: string) => Number(item));
		// const requiredVersion = { ios: [1, 5, 0], aos: [1, 8, 2] };

		// let isUpdateRequired = false;

		// if (isDeviceAOS) {
		// 	if (
		// 		currentVersion[0] < requiredVersion.aos[0] ||
		// 		currentVersion[1] < requiredVersion.aos[1] ||
		// 		currentVersion[2] < requiredVersion.aos[2]
		// 	) {
		// 		isUpdateRequired = true;
		// 	}
		// }

		// if (isDeviceIOS) {
		// 	if (
		// 		currentVersion[0] < requiredVersion.ios[0] ||
		// 		currentVersion[1] < requiredVersion.ios[1] ||
		// 		currentVersion[2] < requiredVersion.ios[2]
		// 	) {
		// 		isUpdateRequired = true;
		// 	}
		// }

		// 텔레그램 입장
		// if (isUpdateRequired) {
		// 	popupStore.openPopup({
		// 		content: MESSAGE_REQUIRED_UPDATE,
		// 		cancel: () => {
		// 			openNativeAppStore();
		// 		},
		// 	});
		// 	return;
		// }

		window.open(getCheckAuthData.value?.data?.member_group_telegram_link, '_blank');
	} else if (!getCheckAuthData.value?.data?.member_group_telegram_link) {
		loginPopupStore.openPopup({
			icon: 'alert',
			content: '텔레그램 링크가 없습니다.',
			subtext: '고객센터로 문의바랍니다.',
			cancel: () => {
				router.push('/notice-detail/126');
			},
			cancelText: '고객센터 연결하기',
		});
	}
};

const handlePremiumEventCollect = async () => {
	await mutatePremiumEventCollect();
	router.push('/subscriber-board-detail/162');
};

// -----function-----
const onClickLogout = () => {
	authStore.resetAuth();
	tokenStore.resetToken();
	router.push({ name: 'home' });
};
</script>

<style scoped lang="scss">
.mobile_mypage {
	padding: var(--header-height) 2rem 0;
	/* box-shadow: 0.4rem 0.4rem 1.5rem 0rem #5a5a5a; */
	height: 100dvh;
	max-width: 68rem;
	width: 100%;
	margin: 0 auto;
	background-color: var(--color-bg);

	display: flex;
	flex-direction: column;
	gap: 1rem;

	&::-webkit-scrollbar {
		display: none;
	}
	overflow-y: auto;
	color: var(--color-base-white);

	.menu_section_wrapper {
		display: flex;
		flex-direction: column;
		gap: 1.6rem;

		.divider {
			display: none;
		}

		&.reverse {
			flex-direction: column-reverse;
			gap: 0;

			padding-bottom: 4.8rem;

			.divider {
				display: block;

				height: 2rem;
				border: none;
				background-color: var(--color-bg-light);

				padding: 0 2rem;
				margin: 0 -2rem;
			}
		}

		.menu_section_wrapper_content {
			display: flex;
			flex-direction: column;
			gap: 1.6rem;
		}
	}

	.user_info_section {
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}

	.user_info {
		display: flex;
		justify-content: center;
		flex-direction: column;
		gap: 1.6rem;

		.user_info_title_box {
			display: flex;
			align-items: center;
			width: 100%;
			gap: 0.8rem;

			.user_info_title {
				font-size: var(--font-s-regular);
				font-weight: var(--font-w-semi-bold);
				line-height: 2.1rem;
				strong {
					color: #1690ff;
				}
			}
		}

		.logout {
			display: flex;
			font-weight: var(--font-w-regular);
			font-size: var(--font-s-mid);
			color: var(--color-base-light);
			line-height: 1.79rem;
			align-items: center;
			span {
				border-bottom: 1px solid var(--color-base-light);
			}
			img {
				width: 1.8rem;
				height: auto;
			}
		}
	}

	.user_subscription_info {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 1.6rem;

		.user_subscription_info_title {
			font-size: var(--font-s-regular);
			font-weight: var(--font-w-semi-bold);
			line-height: 2.1rem;
			b {
				color: #1690ff;
			}
		}

		.user_subscription_info_desc {
			font-size: var(--font-s-small);
			font-weight: var(--font-w-light);
			line-height: 100%;
		}
	}

	.mainMenu {
		margin: 0 -2rem;
		padding-bottom: var(--space-mid);
		.mainTitle {
			font-size: var(--font-size-sm);
			font-weight: var(--font-w-semi-bold);
		}

		.depth1 {
			&:not(:last-child) {
				border-bottom: 1px solid var(--color-base-mid-dark);
			}

			.depth1_title {
				display: flex;
				align-items: center;
				gap: 0.8rem;
				padding: var(--space-mid) var(--space-large);
				font-size: var(--font-s-regular);
				font-weight: var(--font-w-medium);
				line-height: 2.1rem;
				cursor: pointer;

				.title_icon {
					align-items: center;
					display: flex;
					justify-content: center;
				}
			}
		}
	}

	.box_wrapper {
		padding: 2rem;
		background-color: var(--color-bg-mid);
		border-radius: 1rem;

		.user_box {
			display: flex;
			align-items: center;
			width: 100%;
			gap: 1rem;

			.user_content_img {
				width: 6rem;
				height: 6rem;
				border-radius: 6rem;
				background-color: #fff;
				overflow: hidden;
				img {
					object-fit: contain;
					width: 100%;
					height: 100%;
				}
			}
		}
	}

	.subscription_badge {
		padding: 0.2rem 0.8rem;
		border-radius: 9999px;

		width: fit-content;

		font-size: var(--font-s-small);
		font-weight: var(--font-w-light);
		line-height: 1.56rem;
		text-align: center;

		color: var(--color-primary-contrast);
		background-color: var(--color-base-disabled);

		&.active {
			background-color: var(--color-primary);
		}
	}
}

.box_wrapper {
	padding: 2rem;
	background-color: var(--color-bg-mid);
	border-radius: 1rem;
}

.subscription_badge {
	padding: 0.2rem 0.8rem;
	border-radius: 9999px;

	width: fit-content;

	font-size: var(--font-s-small);
	font-weight: var(--font-w-light);
	line-height: 1.56rem;
	text-align: center;

	color: var(--color-primary-contrast);
	background-color: var(--color-base-disabled);

	&.active {
		background-color: var(--color-primary);
	}
}

.menu_section {
	padding-top: 1.6rem;
	display: flex;
	flex-direction: column;
	gap: 1.6rem;

	.title_box {
		display: flex;
		flex-direction: column;
		gap: 0.4rem;

		h3 {
			color: var(--color-primary);
			font-weight: 700;
			font-size: var(--font-s-large);
			line-height: 2.5rem;

			&.premium {
				font-size: var(--font-s-xx-large);
				line-height: 2.8rem;
			}
		}

		p {
			font-weight: var(--font-w-light);
			font-size: var(--font-s-small);
		}
	}

	.menu_list {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 0.8rem 1rem;

		.menu_item {
			cursor: pointer;
			grid-column: 1 / -1;
			background-color: var(--color-bg-mid);
			border-radius: 0.8rem;
			padding: 1.6rem;

			div {
				display: flex;
				align-items: center;
				gap: 1rem;

				p {
					display: flex;
					align-items: center;
					gap: 1rem;

					font-size: var(--font-s-mid);
					font-weight: var(--font-w-semi-bold);
					line-height: 1.8rem;

					.event_badge {
						padding: 0.2rem var(--space-xx-small);

						font-size: var(--font-s-small);
						line-height: 1.56rem;

						border-radius: var(--border-radius-xx-small);
						background-color: var(--color-secondary);
						position: relative;
						display: inline-block;
						animation: sparkle 2s ease-in-out infinite;

						@keyframes sparkle {
							0%,
							100% {
								opacity: 1;
								transform: scale(1);
								box-shadow: 0 0 0.4rem rgba(255, 168, 0, 0.4);
							}
							50% {
								opacity: 0.9;
								transform: scale(1.08);
								box-shadow:
									0 0 0.8rem rgba(255, 168, 0, 0.8),
									0 0 1.2rem rgba(255, 168, 0, 0.5);
							}
						}
					}
				}

				& > svg:last-child {
					margin-left: auto;
				}
			}
		}

		.menu_grid_item {
			cursor: pointer;
			background-color: var(--color-bg-mid);
			border-radius: 0.8rem;
			padding: 1rem;

			div {
				display: flex;
				flex-direction: column;
				align-items: center;
				gap: 0.4rem;

				img {
					width: 2rem;
					height: 2rem;
				}

				p {
					font-weight: var(--font-w-semi-bold);
					font-size: var(--font-s-small);
					line-height: 1.56rem;
					text-align: center;
				}
			}
		}
	}
}

.subscription_button {
	max-width: 20rem;
	width: 100%;
	padding: var(--space-small) var(--space-x-large);
	background-color: var(--color-primary);
	border-radius: var(--border-radius-small);

	color: var(--color-primary-contrast);
	font-size: var(--font-s-large);
	font-weight: var(--font-w-semi-bold);
	line-height: 1;
	text-align: center;
}
</style>
